var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('video-icon');
import { breakpoints, theme } from '@shapeable/theme';
import { PlayCircle } from '../icons/play-circle-icon';
export var VideoIconDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 64px;\n    height: 64px;\n    ", ";\n  "], ["\n    width: 64px;\n    height: 64px;\n    ", ";\n  "])), theme.FILL('light'))
}); // -------- Components -------->

var My = {
  Container: styled(PlayCircle)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var VideoIcon = function VideoIcon(props) {
  var className = props.className;
  return React.createElement(My.Container, {
    className: cls.name(className)
  });
};
export var VideoIconContext = React.createContext(VideoIcon);
export var VideoIconProvider = VideoIconContext.Provider;
export var useVideoIcon = function useVideoIcon() {
  return useContext(VideoIconContext);
};
VideoIcon.defaultProps = VideoIconDefaultProps;
VideoIcon.cls = cls;
var templateObject_1, templateObject_2;